import { HeroCard } from '@gains-com/shared';

/**
 * Lobby hero-card gating for the keyed first-time cards: `welcome_boost`
 * belongs to the purchase (non-merch) experience and `merch_welcome_offer`
 * to the merch experience. Each hides once the user has bought in *its own*
 * mode — `has_had_purchase` counts every mode, so a sweeps purchase would
 * otherwise take the merch offer down with it. Every other card passes
 * through untouched.
 */
export function filterHeroCards(
  cards: HeroCard[],
  opts: { hasHadPurchase: boolean; hasHadMerchPurchase: boolean; merchExperience: boolean }
): HeroCard[] {
  return cards.filter((card) => {
    if (card.key === 'welcome_boost') {
      return !opts.hasHadPurchase && !opts.merchExperience;
    }
    if (card.key === 'merch_welcome_offer') {
      return opts.merchExperience && !opts.hasHadMerchPurchase;
    }
    return true;
  });
}
